module.exports = __webpack_public_path__ + "img/logo2.2fe4914a.png";